/* 🤖 this file was generated by svg-to-ts */
export const matIconGirl: {
  name: 'girl';
  data: string;
} = {
  name: 'girl',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 7.5c.97 0 1.75-.78 1.75-1.75S12.97 4 12 4s-1.75.78-1.75 1.75S11.03 7.5 12 7.5zm2 8.5v4h-4v-4H8l2.38-6.38a1.733 1.733 0 0 1 3.24 0L16 16h-2z"/></svg>`
};
